"use client"

import { FormItem } from "../../ui/shadcn/form"
import { DynamicFormLabel } from "../components/form-label"
import type { ParsedField } from "../types"

interface ObjectFieldProps {
	field: ParsedField
}

export function ObjectField({ field: parsedField }: ObjectFieldProps) {
	const { name, schema, required } = parsedField
	const description = schema.description
	const title = schema.title
	if (!schema.properties) return null

	return (
		<FormItem>
			<fieldset className="rounded-lg border p-4 space-y-4 group">
				<legend className="px-2">
					<DynamicFormLabel name={name} title={title} required={required} description={description} />
				</legend>
				<div className="space-y-4">
					{Object.entries(schema.properties).map(([fieldName]) => (
						<div key={fieldName} className="text-sm text-muted-foreground">
							중첩 객체 필드: {fieldName}
						</div>
					))}
				</div>
			</fieldset>
		</FormItem>
	)
}
